const { getElements } = window.BAO.Utils
class SizeGuide extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.conversion = this.dataset.conversion
    this.headings = this.dataset.headings

    this.sizeTable = this.els?.table?.element?.querySelector('table')

    // this.handleInitialConversion()
    this.setInitialTab()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.trigger?.exists) {
      this.handleTrigger = this.handleTrigger.bind(this)

      this.els.trigger.elements.forEach((el) => {
        this.listeners.add(el, 'click', this.handleTrigger)
      })
    }

    if (this.els?.inches?.exists) {
      this.onInchesClick = this.onInchesClick.bind(this)

      this.els.inches.elements.forEach((el) => {
        this.listeners.add(el, 'click', this.onInchesClick)
      })
    }

    if (this.els?.centimetres?.exists) {
      this.onCentimetresClick = this.onCentimetresClick.bind(this)

      this.els.centimetres.elements.forEach((el) => {
        this.listeners.add(el, 'click', this.onCentimetresClick)
      })
    }
  }

  setInitialTab () {
    const activeTab = this.querySelector(
      '[data-size-guide-el="trigger"][aria-pressed="true"]',
    )

    if (!activeTab) return

    const activeTabValue = activeTab.dataset.tab

    this.setAttribute('data-tab', activeTabValue)
  }

  handleInitialConversion () {
    const handleConversion = (el) => {
      if (el.cellIndex === 0 || el.closest('tr').rowIndex === 0) return

      if (isNaN(el.innerHTML)) return

      const centimetres = parseFloat(el.innerHTML, 10)

      const inches = Math.round((centimetres / 2.54) * 10) / 10

      el.setAttribute('data-centimetres', centimetres)
      el.setAttribute('data-inches', inches)

      if (this.conversion === 'centimetres') {
        el.innerHTML = centimetres
      } else {
        el.innerHTML = inches
      }

      this.els.conversions.element.setAttribute('aria-hidden', 'false')
    }

    getElements('td', { context: this.sizeTable }).forEach((el) =>
      handleConversion(el),
    )
  }

  async onInchesClick () {
    this.convertToInches()

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [this.storageName]: 'inches',
        },
      }),
    })
  }

  async onCentimetresClick () {
    this.convertToCentimetres()

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [this.storageName]: 'centimetres',
        },
      }),
    })
  }

  convertToInches () {
    if (this.conversion === 'inches') return

    this.conversion = 'inches'

    this.els.inches.elements.forEach((el) => {
      el.setAttribute('aria-current', true)
    })

    this.els.centimetres.elements.forEach((el) => {
      el.setAttribute('aria-current', false)
    })

    getElements('td', { context: this.sizeTable }).forEach((el) => {
      if (!el.hasAttribute('data-inches')) return

      el.innerHTML = el.dataset.inches
    })
  }

  convertToCentimetres () {
    if (this.conversion === 'centimetres') return

    this.conversion = 'centimetres'

    this.els.inches.elements.forEach((el) => {
      el.setAttribute('aria-current', false)
    })

    this.els.centimetres.elements.forEach((el) => {
      el.setAttribute('aria-current', true)
    })

    getElements('td', { context: this.sizeTable }).forEach((el) => {
      if (!el.hasAttribute('data-centimetres')) return

      el.innerHTML = el.dataset.centimetres
    })
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)

    this.els.panel.elements.forEach((panelEl) => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.tab !== triggerEl.dataset.tab,
      )
    })

    this.els.trigger.elements.forEach((trigger) => {
      trigger.setAttribute(
        'aria-pressed',
        trigger.dataset.tab === triggerEl.dataset.tab,
      )
    })

    this.setAttribute('data-tab', triggerEl.dataset.tab)
  }

  get storageName () {
    return 'size_guide_conversion'
  }

  get conversions () {
    return {
      Universal: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL', '6XL'],
    }
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}
